<template>
    <div class="mb-3">

        <div class="alert alert-warning" v-if="singleNotAvailable">
            Ezen a túrán kétágyas szobák vannak és nem tudunk lehetőséget biztosítani arra, hogy 1 fő egyedül fogaljon el egy kétágyas szobát.
            Emiatt csak páros számú foglalás leadása lehetséges.
            Ha páratlan létszámú foglalást szeretnél leadni, kérjük vedd fel velünk a kapcsolatot.
        </div>

        <label for="number_of_guests">
            <slot></slot>
        </label>

        <select class="form-select"
                name="number_of_guests"
                id="number_of_guests"
                v-model="formData.number_of_guests"
                required>
            <option value="">
                {{ $t("choose") }}
            </option>
            <option :value="freePlace" v-for="freePlace in freePlaces">
                {{ freePlace }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            required: true,
            type: Boolean,
        },
        formData: {
            required: true,
            type: Object,
        },
        maxAvailablePlaces: {
            required: true,
            type: Number,
        },
        singleNotAvailable: {
            type: Boolean,
        },
    },
    data() {
        return {
            freePlaces: [],
        }
    },
    mounted() {
        for (let freePlace = 1; freePlace <= this.maxAvailablePlaces; freePlace++) {
            if (this.singleNotAvailable && freePlace % 2 !== 0) {
                continue;
            }

            this.freePlaces.push(freePlace);
        }
    },
}
</script>

<style scoped>

</style>
